import { Component, computed, input, Input } from '@angular/core'
import {
  AttributeSelectionsInterface,
  DistinctProductInterfaceType,
  PriceViewInterface,
  Product,
  ProductVariantInterface
} from "@gea-waldviertler-website/gea-models";

import { EuroPricePipe } from '../../pipes/price.pipe'
import { EventStarsComponent } from '../../svg/event-stars/event-stars.component'

@Component({
  selector: 'gea-shop-product-single-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  standalone: true,
  imports: [EuroPricePipe, EventStarsComponent]
})
export class PriceComponent {

  selectedAttributes = input<AttributeSelectionsInterface | undefined>()

  productPrice = computed<PriceViewInterface | undefined>(() => {
    const p = this.product()
    const dp = this.distinctProduct()
    const sa = this.selectedAttributes()
    const fp = this.forcePrice()

    if (fp && typeof fp === 'object') {
      return fp
    }

    if (fp && typeof fp === 'number') {
      return { normal: fp }
    }

    if (! p) {
      return undefined
    }
    const prices = p.getEffectivePrices(sa, dp)

    return prices
  })

  // per default, the product price range or if no range the product price will be shown
  product = input<Product<ProductVariantInterface> | undefined>()
  distinctProduct = input<DistinctProductInterfaceType | undefined>()

  // if a forcePrice is set, this price will be shown instead of the defaults given by the product,
  // set this back to null show the defaults given by the product
  // @Input() forcePrice?: number | null | undefined

  @Input() discount?: number | null | undefined

  forcePrice = input<number | PriceViewInterface | undefined>(undefined)
}
